import { ArrowUp } from '../../../components/ui/icons';

export function PromotionLine({ promote }: { promote: number }) {
  return (
    <div className="flex items-center gap-2 bg-accent/[0.07] px-[15px] py-[5px]">
      <div className="h-px flex-1 bg-accent/30" />
      <span className="inline-flex items-center gap-1 text-[9px] font-extrabold tracking-[0.1em] text-accent-ink">
        <ArrowUp width={10} height={10} strokeWidth={3.4} />
        PROMOTION · TOP {promote}
      </span>
      <div className="h-px flex-1 bg-accent/30" />
    </div>
  );
}
